import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { setSelectedBadge, setTabSelected } from "../../redux/data/dataSlice.js";

import Badge from "../badges/badge";
import BadgeModal from "../badges/badgeModal";
import config from "../../config/memberhubContents.json";
import FrameModal from "../frameModal";
import JebbitModal from "../jebbitModal";
import PollModal from "../polls/pollModal";
import QuizModal from "../quizzes/quizModal";
import RewardModal from "../rewardModal";
import SurveyModal from "../surveys/surveyModal";

import "../../assets/css/badges.css";
import "../../assets/css/overview.css";

function OverviewSwimlane(props) {
    const dispatch = useDispatch();
    const swimlane = useRef(null);
    const [disableBackBtn, setDisableBackBtn] = useState(true);
    const [disableNextBtn, setDisableNextBtn] = useState(false);
    const [openBadgeModal, setOpenBadgeModal] = useState(false);
    const [openBenefitModal, setOpenBenefitModal] = useState(false);
    const [selectedReward, setSelectedReward] = useState(null);
    const selectedBadge = useSelector(state => state.data.selectedBadge);

    const section = props.section;
    const title = props.title;
    const subtitle = props.subtitle;

    const swimlaneRewardWidth = 284; // tile width in px

    const codeAccessed = data => data.reference_id === "code_code" && data.redeemed && data.redeemed.codes;
    const isSoldOut = data => data.reference_id === "code_code" && !data.redeemed && data.extra_data &&
        data.extra_data.sold_out === "1" && data.max_select_quantity === 0;

    const handleScroll = e => {
        setDisableBackBtn(swimlane.current.scrollLeft === 0);
        setDisableNextBtn(Math.ceil(swimlane.current.scrollLeft + swimlane.current.offsetWidth) >= swimlane.current.scrollWidth);
    };

    const handleClickNext = e => {
        swimlane.current.scrollBy({
            left: swimlaneRewardWidth,
            behavior: "smooth",
        });
    };
    
    const handleClickBack = e => {
        swimlane.current.scrollBy({
            left: -swimlaneRewardWidth,
            behavior: "smooth",
        });
    };

    const getModalByReward = () => {
        if(selectedReward) {
            if(props.type === "voting") {
                if(selectedReward.extra_data.jebbit_campaign_id) {
                    return <JebbitModal selectedCampaign={selectedReward.extra_data.jebbit_campaign_id} setShowModal={setOpenBenefitModal} />;
                }
                if(selectedReward.extra_data.game) {
                    return <FrameModal campaignUrl={selectedReward.extra_data.game} setShowModal={setOpenBenefitModal} overview={true} closeModal={() => {
                        dispatch(setSelectedBadge(null));
                        setSelectedReward(null);
                        setOpenBenefitModal(false);
                        setOpenBadgeModal(false);
                    }}/>
                }
                if(selectedReward.extra_data.host && selectedReward.extra_data.project_id && selectedReward.extra_data.event_id) {
                    const monterosaUrl = `/monterosa.htm?id=${encodeURIComponent(selectedReward.extra_data.project_id)}&e=${encodeURIComponent(selectedReward.extra_data.event_id)}`;
                    return <FrameModal setShowModal={setOpenBenefitModal} campaignUrl={monterosaUrl} overview={true} closeModal={() => {
                        dispatch(setSelectedBadge(null));
                        setSelectedReward(null);
                        setOpenBenefitModal(false);
                        setOpenBadgeModal(false);
                    }}/>
                }
            }

            if(selectedReward.activity_channel_name) {
                switch (selectedReward.activity_channel_name) {
                    case "quiz":
                        return <QuizModal quiz={selectedReward} setShowModal={setOpenBenefitModal} />;
                    case "poll":
                        return <PollModal selectedPoll={selectedReward} setShowModal={setOpenBenefitModal} />;
                    case "survey":
                        return <SurveyModal survey={selectedReward} setShowModal={setOpenBenefitModal} />;
                    default:
                        return <RewardModal selectedReward={selectedReward} setShowModal={setOpenBenefitModal} />;
                }
            }

            return <RewardModal selectedReward={selectedReward} setShowModal={setOpenBenefitModal} />;
        }
    };

    useEffect(() => {
        if (swimlane) {
            setDisableNextBtn(swimlane.current.scrollWidth === swimlane.current.clientWidth);
        }
    }, [swimlane]);
    
    const renderSwimlaneContent = () => {
        if(section && (section.rewards || section.badges)) {
            switch (props.type) {
                case "badge":
                    return section.badges.map((badge, i) => 
                        <Badge badge={badge} key={i} overview={true} onClick={() => {
                            dispatch(setSelectedBadge(badge));
                            setSelectedReward(null);
                            setOpenBenefitModal(false);
                            setSelectedBadge(badge);
                            setOpenBadgeModal(true);
                        }}></Badge>
                    );
                case "benefit":
                case "voting":
                default:
                    return section.rewards.map((reward, i) => 
                        <div className="overview-reward" key={i}
                            onClick={() => {
                                dispatch(setSelectedBadge(null));
                                setOpenBadgeModal(false);
                                setSelectedReward(reward);
                                setOpenBenefitModal(true);
                            }
                        }>
                            <div className="reward-img-container">
                                    { (isSoldOut(reward) || codeAccessed(reward)) && <div className="reward-card-tag">
                                        <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 h-6 overflow-hidden rounded border border-white/40">
                                            <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 relative gap-1 px-2 py-1 bg-black/60">
                                                <p className="flex-grow-0 flex-shrink-0 text-xs font-bold text-center text-white">
                                                    { isSoldOut(reward) ? reward.extra_data.sold_out_tag ? reward.extra_data.sold_out_tag : config.soldout : config.accessed }
                                                </p>
                                            </div>
                                        </div>
                                        <div className="flex-grow h-[21px] opacity-0 bg-[#c4c4c4]" />
                                    </div>}
                                <img className={`reward-img${isSoldOut(reward) || codeAccessed(reward) ? " sold-out" : ""}`} src={reward.image} alt={`Reward: ${reward.title}`}/>
                            </div>
                            <div className="reward-text">{reward.title}</div>
                        </div>
                    );
            }
        }
    };

    return (
        <>
            <div className="overview-swimlane-container">
                <div className="swimlane-top">
                    <div className="swimlane-title">
                        {title ? title : section.title ? section.title : section.name ? section.name : ""}
                    </div>
                    <Link className="swimlane-see-more" to={{ pathname: `/${props.more}` }}
                        onClick={e => {
                            document.getElementById("nba-nav").scrollIntoView();
                            dispatch(setTabSelected(props.more));
                        }}>
                        More <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9.5" cy="9.5" r="9.5" fill="#FBCD44"/>
                            <path d="M13.5414 10.6183C13.7554 10.4042 13.7554 10.0572 13.5414 9.84316L10.0535 6.35522C9.83942 6.14119 9.49239 6.14119 9.27836 6.35522C9.06432 6.56926 9.06432 6.91628 9.27836 7.13032L12.3787 10.2307L9.27836 13.3311C9.06432 13.5451 9.06432 13.8922 9.27836 14.1062C9.49239 14.3202 9.83942 14.3202 10.0535 14.1062L13.5414 10.6183ZM4.79144e-08 10.7788L13.1538 10.7788L13.1538 9.68263L-4.79144e-08 9.68264L4.79144e-08 10.7788Z" fill="black"/>
                        </svg>
                    </Link>
                </div>
                <div className="swimlane-subtitle">
                    {subtitle ? subtitle : section.subtitle ? section.subtitle : section.desc ? section.desc : ""}
                </div>
                <div className="swimlane-content">
                    <button className={`control-button back ${disableBackBtn ? 'off' : ''}`} onClick={handleClickBack}></button>
                    <div className="overview-swimlane" ref={swimlane} onScrollCapture={handleScroll}>
                        { renderSwimlaneContent() }
                    </div>
                    <button className={`control-button next ${disableNextBtn ? 'off' : ''}`}  onClick={handleClickNext}></button>
                </div>
            </div>
            {(openBenefitModal || openBadgeModal) &&
                <div className="modal-container">
                    <div className="modal-background"></div>
                    <div className="modal-dialog">
                        {selectedBadge && <BadgeModal overview={true} closeModal={() => {
                            dispatch(setSelectedBadge(null));
                            setSelectedReward(null);
                            setOpenBenefitModal(false);
                            setOpenBadgeModal(false);
                        }}/>}
                        {selectedReward ? <>{getModalByReward()}</> : <div>aa</div>}
                    </div>
                </div>
            }
        </>
    );
}

export default OverviewSwimlane;
